// ============================================================================
// Prod-/Beta-Wechsel mit Transfer-Token (W7-H, Portierung von
// public/js/settings.js:1692-1742).
// ----------------------------------------------------------------------------
// Der Server stellt unter POST /api/auth/transfer-token einen 60 Sekunden
// gueltigen JWT aus — fuer Admins und Mitgliedschaften mit Beta-Zugang
// :2677-2692). Die Zielumgebung tauscht ihn beim ersten Seitenaufruf gegen
// ein normales Auth-Cookie (server/index.js:960-987, `?_auth=`), der
// Parameter faellt dabei per Redirect aus der URL.
//
// `wtn=1` bleibt erhalten: der Server nutzt den Parameter weiterhin zur
// Native-Erkennung (lorath_native-Cookie).
// ============================================================================

export const PROD_BASE_URL = 'https://app.lorath.eu';
export const BETA_BASE_URL = 'https://beta.lorath.eu';

export interface BetaEnvironmentInput {
  /** <html data-app-env> — vom Server gesetzt, die verlaesslichste Quelle. */
  appEnv?: string | null;
  /** Web: der Hostname der laufenden Seite. */
  hostname?: string | null;
  /** Nativ: die einkompilierte API-Basis (app.lorath.eu bzw. beta.lorath.eu). */
  apiBase?: string | null;
}

/** Laeuft die App gerade gegen die Beta-Umgebung? */
export function detectIsBetaEnvironment(input: BetaEnvironmentInput): boolean {
  if (input.appEnv === 'beta') return true;
  // Im nativen Build ist der Hostname 'localhost' — dort entscheidet die
  // API-Basis, gegen die das Bundle gebaut wurde.
  if (input.hostname?.includes('beta')) return true;
  if (input.apiBase?.includes('beta.')) return true;
  return false;
}

/** Ziel-URL fuer den Wechsel: von Beta nach Produktion und umgekehrt. */
export function buildTransferUrl(isBeta: boolean, token: string): string {
  const target = isBeta ? PROD_BASE_URL : BETA_BASE_URL;
  return `${target}/dashboard?_auth=${encodeURIComponent(token)}&wtn=1`;
}

/** Darf dieses Konto die Umgebung wechseln? Spiegelt den Servercheck. */
export function maySwitchEnvironment(user: { role?: unknown; is_admin?: unknown; beta_access?: unknown } | null | undefined): boolean {
  if (!user) return false;
  if (user.is_admin === true) return true;
  // Übergang: Tester-Rolle wird bis zum Rollen-Cutover weiter akzeptiert,
  // damit die laufende Prod-App nichts verliert. Server prüft dasselbe.
  if (user.role === 'admin' || user.role === 'tester') return true;
  return user.beta_access === true;
}
